import { render, staticRenderFns } from "./DataCorrectionModal.vue?vue&type=template&id=4cab49e2&scoped=true"
import script from "./DataCorrectionModal.vue?vue&type=script&lang=js"
export * from "./DataCorrectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab49e2",
  null
  
)

export default component.exports